module.exports = __webpack_public_path__ + "6a50ef3b2138902523b99532f111c321.png";